export default "__VITE_ASSET__DclZtmZ6__"